<template>
  <div :class="computedClassName" :style="style">
    <div class="hero-content">
      <picture v-show="!hasError" class="hero-content__picture">
        <source
          media="(min-width:769px)"
          :srcset="imageLarge"
          data-testid="image-large"
        />
        <source
          media="(min-width:480px)"
          :srcset="imageMedium"
          data-testid="image-medium"
        />
        <img
          v-show="imageSmall"
          :src="imageSmall"
          alt="Ilustração da tela"
          width="100%"
          height="100%"
          loading="lazy"
          data-testid="image-small"
          class="hero-content__picture--img"
          @load="handleLoad"
          @error="handleError"
        />
      </picture>
    </div>
    <div class="hero__content">
      <div class="max-width">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component
export default class Hero extends Vue {
  @Prop({ type: String })
  readonly imageSmall?: string;

  @Prop({ type: String })
  readonly imageMedium?: string;

  @Prop({ type: String })
  readonly imageLarge?: string;

  @Prop({ type: Boolean, default: false })
  readonly showOverlay!: boolean;

  @Prop({ type: String, default: '80vh' })
  readonly height!: string;

  @Prop({ type: String, default: NebraskaColors.themePrimary })
  readonly bgColor!: string;

  private hasError = false;

  private handleLoad() {
    this.hasError = false;
  }

  private handleError() {
    this.hasError = true;
  }

  public get style() {
    return {
      height: this.height,
      background: this.bgColor
    };
  }

  public get computedClassName() {
    return ['hero', { 'hero-overlay': this.showOverlay }];
  }
}
</script>

<style lang="less" scoped>
.max-width {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.hero {
  position: relative;
  display: inline-flex;
  height: 100%;
  width: 100%;

  &-content {
    position: absolute;
    height: 100%;
    width: inherit;
    top: 0;

    &__picture {
      width: 100%;

      &--img {
        object-fit: cover;
      }
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    padding: 0 @size-spacing-x400;
    margin: 0 auto @size-spacing-x900;
    z-index: 10;
  }
}

.hero-overlay::before {
  content: '';
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background: @background-overlay;
  z-index: 10;
}
</style>
